import {
  FavoritesFilled,
  Food,
  Home,
  Fuel,
  Hospital,
  Recent,
  Work,
  Parking,
} from './quick-links/index';

import {
  Close,
  Filter,
  FavoritesEmptyGray,
  routebarArrow,
  Delete,
  Direction,
  Dot,
  Edit,
  Star,
  StarEmpty,
  ArrowBack,
  ArrowRight,
  Collapse,
  RecentLightGray,
  FavoritesEmptyBlack,
  Add,
  FavoritesFilledRed,
} from './general';

import {
  continueStraight,
  destinationLeft,
  destinationRight,
  exitLeft,
  exitRight,
  ferry,
  keepLeft,
  keepRight,
  mergeLeft,
  mergeRight,
  roundaboutCCW45,
  roundaboutCCW90,
  roundaboutCCW135,
  roundaboutCCW180,
  roundaboutCCW225,
  roundaboutCCW270,
  roundaboutCCW315,
  roundaboutCW45,
  roundaboutCW90,
  roundaboutCW135,
  roundaboutCW180,
  roundaboutCW225,
  roundaboutCW270,
  roundaboutCW315,
  sharpLeft,
  sharpRight,
  slightLeft,
  slightRight,
  toll,
  turnLeft,
  turnRight,
  uTurnLeft,
  uTurnRight,
} from './navigation-arrows/index';

import { Clock, Price, GPS, StarGray } from './sort-by/index';

const Icons = {
  general: {
    Close,
    Filter,
    FavoritesEmptyGray,
    FavoritesEmptyBlack,
    routebarArrow,
    Delete,
    Direction,
    Dot,
    Edit,
    Star,
    StarEmpty,
    ArrowBack,
    ArrowRight,
    Collapse,
    RecentLightGray,
    Add,
    FavoritesFilledRed,
  },
  quickLinks: {
    Close,
    Filter,
    FavoritesFilled,
    Food,
    Home,
    Fuel,
    Hospital,
    Recent,
    Work,
    Parking,
  },
  navigation: {
    continueStraight,
    destinationLeft,
    destinationRight,
    exitLeft,
    exitRight,
    ferry,
    keepLeft,
    keepRight,
    mergeLeft,
    mergeRight,
    roundaboutCCW45,
    roundaboutCCW90,
    roundaboutCCW135,
    roundaboutCCW180,
    roundaboutCCW225,
    roundaboutCCW270,
    roundaboutCCW315,
    roundaboutCW45,
    roundaboutCW90,
    roundaboutCW135,
    roundaboutCW180,
    roundaboutCW225,
    roundaboutCW270,
    roundaboutCW315,
    sharpLeft,
    sharpRight,
    slightLeft,
    slightRight,
    toll,
    turnLeft,
    turnRight,
    uTurnLeft,
    uTurnRight,
  },
  sortBy: {
    Price,
    GPS,
    StarGray,
    Clock,
  },
};

export default Icons;
